import { useEffect, useRef } from 'react';


export interface UseOverlapErrorBaselineResult {
  /** Fija el baseline tras un error de solapamiento (llamar con las fechas enviadas al backend). */
  setBaseline: (startDate: string, endDate: string) => void;
}

/**
 * Comparte la lógica de creación y edición de licencia médica: tras un error de solapamiento
 * de fechas (`CONFLICT_DATE_OVERLAP`) se fija un baseline; si el usuario cambia luego
 * `startDate` o `endDate` respecto a ese baseline, se limpian los errores para evitar que quede
 * un mensaje de error obsoleto en pantalla.
 */
export function useOverlapErrorBaseline(
  startDate: string,
  endDate: string,
  clearErrors: (fields: ('startDate' | 'endDate')[]) => void,
): UseOverlapErrorBaselineResult {
  const baselineRef = useRef<{ startDate: string; endDate: string } | null>(null);

  useEffect(() => {
    const baseline = baselineRef.current;
    if (!baseline) return;
    if (baseline.startDate !== startDate || baseline.endDate !== endDate) {
      baselineRef.current = null;
      clearErrors(['startDate', 'endDate']);
    }
  }, [startDate, endDate, clearErrors]);

  return {
    setBaseline: (nextStartDate: string, nextEndDate: string) => {
      baselineRef.current = { startDate: nextStartDate, endDate: nextEndDate };
    },
  };
}

export default useOverlapErrorBaseline;
